import React, { Component } from "react";

import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import Icon from '@material-ui/core/Icon';
import IconButton from '@material-ui/core/IconButton';
import AddShoppingCartIcon from '@material-ui/icons/AddShoppingCart';
import SvgIcon from '@material-ui/core/SvgIcon';
import ChatBubbleOutline from '@material-ui/icons/ChatBubbleOutline';
import ListAltIcon from '@material-ui/icons/ListAlt';
import AssignmentIndIcon from '@material-ui/icons/AssignmentInd';
import { Link } from 'react-router-dom';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import UserConfigurationContainer from "../../Containers/UserConfigurationContainer.js";

class CurriculumRow extends Component {
	constructor() {
		super();
		this.state= {
			isOpen: false,
		}
		
		this.switchOpen = this.switchOpen.bind(this);
		this.renderTask = this.renderTask.bind(this);
		this.drawRatings = this.drawRatings.bind(this);
		this.drawLastTerm = this.drawLastTerm.bind(this);
	}
	
	switchOpen(){
		this.setState(prevState => ({isOpen: !prevState.isOpen}));
	}
	
	renderTask(t){
		return <li>{t.taskName}<ul>{t.languageCodes.map(lc => <li>{lc}</li>)}</ul></li>
	}
	
	drawLastTerm(){
		let terms = [" - Inicial", " - I"," - II"," - III"," - IV"];
		if((typeof this.props.rating !== 'undefined') && (typeof this.props.rating.lastTerm !== 'undefined')){
			return this.props.rating.lastTerm.year+"-"+terms[this.props.rating.lastTerm.quarter]
		}else{
			return "";
		}
	}
	
	drawRatings(){
		if((typeof this.props.rating!== 'undefined') && this.props.rating.rating.length>0){
			return (this.props.rating.rating.reduce((x, z) => x + z, 0)/this.props.rating.rating.length).toFixed(2);
		}else{
			return "";
		}
	}
	
	render() {
		//console.log(this.props);
		//const languages = l;
		//<TableCell><Link to={`/curriculumForm/${this.props.curriculum.id}`}><Icon style={{ fontFamily: "tipoecl", fontSize: "21px", color: "#000", cursor: "pointer"}}>&#59424;</Icon></Link></TableCell>
		const languages = this.state.isOpen &&  <ul>{this.props.products.tasks.map(this.renderTask)}</ul>
		return (
			<TableRow hover key={this.props.curriculum.id}>
				<TableCell>{this.props.curriculum.id}</TableCell>
				<TableCell>{this.props.curriculum.user.username}</TableCell>
				<TableCell>{this.props.curriculum.user.firstName+" "+this.props.curriculum.user.lastName}</TableCell>
				<TableCell>
					<IconButton
						aria-label="expand row"
							size="small"
							onClick={this.switchOpen}
						>
							{this.state.isOpen ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
					</IconButton>
					{this.state.isOpen && languages}
				</TableCell>
				<TableCell>{this.drawLastTerm()}</TableCell>
				<TableCell>{this.drawRatings()}</TableCell>
				<TableCell>
					<Link to={`/userConfiguration/${this.props.curriculum.user.id}`}><ListAltIcon style={{fontSize: "21px", color: "#000", cursor: "pointer"}} /></Link>
				</TableCell>
				<TableCell>
					<Link to={`/curriculumForm/${this.props.curriculum.id}`}><AssignmentIndIcon style={{fontSize: "21px", color: "#000", cursor: "pointer"}} /></Link>
				</TableCell>
			</TableRow>
		);
	}
}

export default CurriculumRow;